"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const react_device_detect_1 = require("react-device-detect");
require("./button.css");
;
/**
 * Main component.
 * @name button
 * @param {ButtonProps}
 * @returns {<Button />}
*/
const Button = ({ children, onClick, style, className, type, }) => {
    if (react_device_detect_1.isMobile) {
        return (react_1.default.createElement("button", { onClick: onClick, className: `mobile-button ${className}`, style: style, type: type }, children));
    }
    else {
        return (react_1.default.createElement("button", { onClick: onClick, style: style, className: className, type: type }, children));
    }
};
exports.Button = Button;
//# sourceMappingURL=button.js.map